import { getQueryStringParameter, clearInputField } from '../../../helpers';

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'categorization') {
    return;
  }

  const $investorCategoryRadio = $('#investor_categorization_buttons input[type=radio]', $form);

  $investorCategoryRadio.on('change', (e) => {
    if (!e.target.checked) return;

    if (e.target.name.includes('[investor_categorization]')) {
      let $investoryCategoryNestedFields = $('.investor_categorization_nested_fields', $form);
      let selectedInvestorCategoryNestedFieldsID = `${e.target.value}_nested_fields`;

      $investoryCategoryNestedFields.each((_, fields) => {
        if (fields.id === selectedInvestorCategoryNestedFieldsID) {
          $(fields).removeClass('d-none');
        } else {
          $(fields).addClass('d-none');
          $('input', fields).each((_, inputElement) => {
            clearInputField(inputElement);
          });
        }
      });
    } else if (e.target.name.includes('[professional_client_categorization]')) {
      $('#big_company_criteria_fields', $form).toggleClass('d-none', e.target.value !== 'other_big_company');
    }
  });
});
